import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { bindActionCreators } from 'redux'
import VbProductsContainer from './Products/VbProductsContainer'
import ThirdPartyProductsContainer from './Products/ThirdPartyProductsContainer'
import VismaVceModal from '../../Components/Customer/VismaVceModal'
import {useTranslation} from 'react-i18next';
import InternalLeadSendEmailModal from '../../Components/Customer/SendInternalLeadEmailModal'
import AOCustomerInformationModal from './AOCustomerInformationModal';
import AoCustomerInformation from "../../Components/Customer/CustomerComponents/AoCustomerInformation";
import TabsCard from '../../Components/Card/TabsCard';
import helpers from "../../Utils/helpers";
import { CardContainer, CardRow, DefaultCard} from '../../Components/Card/Card';
import SubscriptionContainer from "./Products/SubscriptionContainer";
import MainInfoContainer from "./MainInfoContainer";
import InternalInfoContainer from "./InternalInfoContainer";
import InyettDetails from "../../Components/Customer/CustomerComponents/InyettDetails";
import TransactionServices from "../../Components/Customer/CustomerComponents/TransactionServices";
import CustomerConnectionsEditModal from "../../Components/Customer/Modals/CustomersConnectionsEditModal";
import CustomerConnections from "../../Components/Customer/CustomerComponents/CustomerConnections";
import Migrations from "../../Components/Customer/CustomerComponents/Migrations";
import CustomerInteractions from "../../Components/Customer/CustomerComponents/CustomerInteractions";
import Edit2faModal from "../Modals/Edit2faModal";
import {availableLayouts} from "../../Constants/MainContainer/layouts";
import useModal from "../../Hooks/useModal";
import modals from "../../Constants/modals";
import commonActionsImp from '../../Actions/commonActions';
import customerActionsImp from '../../Actions/customerActions';
import useFeatureFlags from "../../Hooks/useFeatureFlags";
import {availableCards} from "../../Constants/MainContainer/availableCards";

const saveSearchHistory = customer => {
    const storage = localStorage.getItem("CustomerSearchHistory");
    const history = storage ? JSON.parse(storage) : [];

    const customerNumber = customer.vbCustomer?.customerNumber ?? customer.vossCustomer?.customerNumber

    const customerSearchHistory = {
        customerNumber: customerNumber,
        pathId: customer.pathId,
        organizationNumber: customer.vbCustomer?.organizationNumber ?? customer.vossCustomer?.organizationNumber,
        name: customer.vbCustomer?.name ?? customer.vossCustomer?.name,
    }

    const index = history.findIndex(item => item.customerNumber === customerNumber || item.customerNumber === customerNumber?.toString())

    if (index >= 0)
        history.splice(index, 1);

    if (history.length === 10)
        history.splice(0, 1);

    history.push(customerSearchHistory);

    localStorage.setItem("CustomerSearchHistory", JSON.stringify(history))
}

export function MainContainer({ customerInfoOption }) {
    const customer = useSelector((state) => state.CustomerReducer.customer);
    const user = useSelector((state) => state.CommonReducer.user);
    const aoCustomerInfo = useSelector((state) => state.CustomerReducer.aoCustomerInfo);
    const dispatch = useDispatch();
    const commonActions = bindActionCreators(commonActionsImp, dispatch);
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    
    const { t } = useTranslation();
    
    const [modalName, setModalName] = useState(null);
    const { closeModal, isModalOpen } = useModal();

    useEffect(() => {
        if (helpers.isAoCustomer(customer.vbCustomer)) {
            commonActions.loadDropdownList("AoSuppliers");
            customerActions.getAOCustomerInfo(customer.vbCustomer.customerNumber);
        }

        saveSearchHistory(customer);
    }, []);

    const toggleModal = (modalName, emailTemplate) => {
        if (emailTemplate)
            customerActions.setInternalLeadsEmailTemplate(emailTemplate);

        commonActions.showModal(!!modalName);
        setModalName(modalName);
    };
    function getTabs(block) {
        let tabs = []
        block.tabs?.map(tab => {
            let component = renderTabs(tab);
            if (component)
                tabs.push({
                    name: tab.id,
                    label: t(tab.title),
                    id: tab.id,
                    content: component
                })
        })

        return tabs;
    }
    function renderTabs(block) {
        switch(block.id) {
            case availableCards.InyettDetails.id: return customer.orgNo && <InyettDetails key={block.id}/>
            case availableCards.Transactions.id: return customer.vbCustomer && customer.orgNo && <TransactionServices key={block.id} toggleModal={toggleModal}/>
            case availableCards.CustomerConnections.id: return customer.vbCustomer && customer.orgNo && <CustomerConnections key={block.id}/>
            case availableCards.CustomerInteractions.id: return <CustomerInteractions key={block.id}/>
            case availableCards.AoCustomerInfo.id: return helpers.isAoCustomer(customer.vbCustomer) && <AoCustomerInformation key={block.id} toggleModal={toggleModal} user={user} aoCustomerInfo={aoCustomerInfo}/>
            case availableCards.Migrations.id: return <Migrations key={block.id}/>
            default: return <></>
        }
    }
    function renderCards(block) {
        switch (block.id) {
            case availableCards.Main.id: return <MainInfoContainer key={block.id} toggleModal={toggleModal} />
            case availableCards.Internal.id: return <InternalInfoContainer key={block.id} toggleModal={toggleModal}/>
            case availableCards.Transactions.id: return customer.vbCustomer && customer.orgNo && <DefaultCard title={t(block.title)}><TransactionServices toggleModal={toggleModal}/></DefaultCard>
            case availableCards.Vbproducts.id: return customer.vbCustomer && customer.orgNo && <VbProductsContainer key={block.id} />
            case availableCards.Subscriptions.id: return customer.vossCustomer && <SubscriptionContainer key={block.id} />
            case availableCards.ThirdPartyProducts.id: return customer.orgNo && <ThirdPartyProductsContainer key={block.id} />
            case availableCards.TabsCard.id: {
                let tabs = getTabs(block);
                return tabs?.length > 0 && (
                    <TabsCard key={block.id}>
                        {tabs.map((tab, idx) => (
                            <TabsCard.Tab
                                key={tab.id || tab.name || idx}
                                label={tab.label}
                                disabled={tab.disabled}
                            >
                                <TabsCard.TabBody>
                                    {tab.content}
                                </TabsCard.TabBody>
                            </TabsCard.Tab>
                        ))}
                    </TabsCard>
                );
            }
            default: return <></>
        }
    }
    function renderCardRow(row, index) {
        const hasColumns = row instanceof Array

        let id = row.id ? row.id : row.map(c => c.id)?.join('');
        return (<CardRow orientation={hasColumns ? "horizontal" : ""} key={id}>
            {hasColumns ? row.map((card) => { return renderCards(card)}): renderCards(row)}
        </CardRow>)
    }
    function renderContainer(row) {
        return (<>
                <CardContainer>
                    {row.map((row, index) => renderCardRow(row, index))}
                </CardContainer>
            </>
        )
    }
    
    function selectLayout() {
        return availableLayouts[customerInfoOption ?? user?.teamId] || availableLayouts.default;
    }

    const layout = selectLayout();

    return (
        <>
            {modalName === "showVismaVceModal" && <VismaVceModal onClose={toggleModal} />}
            {isModalOpen(modals.InternalLeadEmail) && <InternalLeadSendEmailModal onClose={closeModal} />}
            {modalName === "updateAOCustomerInfoModal" && <AOCustomerInformationModal onClose={toggleModal} />}
            {isModalOpen(modals.EditCustomerConnections) && <CustomerConnectionsEditModal onClose={closeModal}/>}
            {isModalOpen(modals.Edit2Fa) && <Edit2faModal onClose={closeModal} />}
            {renderContainer(layout.cards)}
        </>)
}